import React from 'react'
import Modal from 'react-modal'
import styles from './confirmationDialog.scss'
import cs from 'classnames'
import underscore from 'underscore'
import nesProp from 'nested-property'
import {hideEmailSenderConfirmationModal} from 'state/actions'
import {connect} from 'react-redux'
import i18n from 'lib/i18n'

const _ = i18n('confirmationDialog')

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        wordWrap: "break-word"
	},
}

@connect((state) => ({
    confirmationModal: state.emailSender.confirmationModal
}))
export default class ConfirmationDialog extends React.Component {
	static propTypes = {
        modalIsOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string,
	    options: React.PropTypes.object,
        contentData: React.PropTypes.any
    }
    constructor(props) {
        super(props)
        //this.handleKeyPress = this.handleKeyPress.bind(this);
		this.state = {templates: null, confirmationModal: props.contentData || props.confirmationModal}

    }
	/* componentWillUnmount () {
		document.body.removeEventListener('keyup', this.props.onCancel, false);
	}
	handleKeyPress (evt) {
		if (vkey[evt.keyCode] === '<escape>') {
			this.props.onCancel();
		}
	}
	componentDidMount() {
        document.body.addEventListener('keyup', this.props.onCancel, false);
    } */

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.confirmationModal &&
            JSON.parse(JSON.stringify(nextProps.confirmationModal)) !==
                (this.props.confirmationModal && JSON.parse(JSON.stringify(this.props.confirmationModal))) &&
            !nextProps.contentData
        ) {
            this.setState({confirmationModal: nextProps.confirmationModal})
        }

        if (
            nextProps.contentData &&
            JSON.parse(JSON.stringify(nextProps.contentData)) !==
            (this.props.contentData && JSON.parse(JSON.stringify(this.props.contentData)))
        ) {
            this.setState({confirmationModal: nextProps.contentData})
        }
    }

    /**
     * This function opens a print window with the modal content
     */
    onPrint() {
        const {options} = this.props
        const {confirmationModal} = this.state
        const theWindow = window.open('', 'PRINT', 'height=600,width=800')

        theWindow.document.write('<html><head><title>' + confirmationModal.title  + '</title>')
        theWindow.document.write('</head><body >')
        theWindow.document.write(confirmationModal.message)
        theWindow.document.write('</body></html>')
        theWindow.document.close() // IE >= 10
        theWindow.focus() // IE >= 10
        theWindow.print()
        // theWindow.close()

        return true;
    }

	render() {
        const {modalIsOpen, onCancel, onConfirmation, cancelLabel, confirmationLabel,
            options} = this.props
        const {confirmationModal} = this.state
        let hasCancelButtonStyle = nesProp.get(options, 'hasCancelButtonStyle')
        let noButtons = nesProp.get(options, 'noButtons')
        let showPrintButton = nesProp.get(options, 'showPrintButton')
        let printButtonLabel = nesProp.get(options, 'printButtonLabel') || ""

		return (
            <div>
				<Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>{confirmationModal && confirmationModal.title}</div>
                        <div className={styles.contentWrapper}>
                            <div className={styles.content}>
                                {confirmationModal &&
                                    <div dangerouslySetInnerHTML={{__html: confirmationModal.message}}/>
                                }
                            </div>
                            <div className={styles.buttons}>

                                {!noButtons &&
                                <div
                                    onClick={() => onCancel()}
                                    className={cs((hasCancelButtonStyle ? styles.cancel : ""))}
                                >
                                    {cancelLabel}
                                </div>}

                                {!noButtons && showPrintButton && <div
                                    onClick={() => {this.onPrint(confirmationModal)}}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {printButtonLabel}
                                </div>}

                                {!noButtons &&
                                <div
                                    onClick={onConfirmation}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {confirmationLabel}
                                </div>}
                            </div>
                        </div>
                    </div>

                </Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/emailSender/confirmationDialog.jsx